// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
//import colors from "vuetify/util/colors";

// Vuetify
import { createVuetify } from "vuetify";

//export default createVuetify();

export default createVuetify({
  rtl: true,
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          //color2: colors.orange.darken3,
          primary: "#b45a32", // your primary color
          secondary: "#502814",
          accent: "#6e643c",
          Light1: "#c8be96", // background color, color for cards, etc.
          background2: "#e1e1c8", // light background.
          background3: "#fffcee", // extra light background, white alternative
        },
      },
    },
  },
});

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
